import * as pdfjsLib from 'pdfjs-dist'

pdfjsLib.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`

export const isPdfUrl = async (url: string): Promise<boolean> => {
  if (/\.pdf($|\?)/i.test(url)) return true
  try {
    const res = await fetch(url, { method: 'HEAD' })
    const type = res.headers.get('content-type') || ''
    return type.toLowerCase().includes('application/pdf')
  } catch {
    return false
  }
}

export const pdfToImageBlob = async (
  url: string,
  scale = 2
): Promise<Blob> => {
  const buffer = await (await fetch(url)).arrayBuffer()
  const pdf = await pdfjsLib.getDocument({ data: buffer }).promise
  const page = await pdf.getPage(1)
  const viewport = page.getViewport({ scale })

  const canvas = document.createElement('canvas')
  canvas.width = viewport.width
  canvas.height = viewport.height
  const context = canvas.getContext('2d')
  if (!context) throw new Error('Failed to get 2D canvas context')

  await page.render({ canvasContext: context, viewport }).promise

  return await new Promise<Blob>((resolve, reject) => {
    canvas.toBlob(
      (blob) => (blob ? resolve(blob) : reject(new Error('toBlob returned null'))),
      'image/jpeg',
      0.92
    )
  })
}
